var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',[_c('h5',{staticClass:"text-capitalize mb-75"},[_vm._v("name")]),_c('b-card-text',[_vm._v(" "+_vm._s(_vm.eduProgram.name)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }